import * as React from 'react';
import * as classNames from 'classnames';
import * as styles from './social.module.sass';
import {FacebookAuth, IFacebookResponse} from '../../facebook-auth/facebook-auth';
import {GoogleAuth, IGoogleResponse} from '../../google-auth/google-auth';
import {IconGroup} from '../../icon-group/icon-group';
import {AuthTooltip as Tooltip} from '../tooltip/tooltip';
import {mapFacebookResponse, mapGoogleResponse} from '../service';

export interface ISocialProps {
  tooltipDisabled?: boolean;
  tooltipLabel?: string;
  externalError: string;
  className?: string;
  disabled?: boolean;
  onAuth?: (payload?: any) => void;
}

interface ISocialState {
  providerError: string;
}

const CANNOT_AUTHORIZE: string = 'Cannot authorize';

export class AuthSocial extends React.Component<ISocialProps, ISocialState> {

  public state: ISocialState = {
    providerError: '',
  };

  public render(): React.ReactElement<{}> {
    const {
      tooltipDisabled,
      tooltipLabel,
      externalError,
      className,
      disabled,
    } = this.props;

    const {providerError} = this.state;
    const buttonClassNames = classNames('btn btn_social', className);

    return (
      <div className={classNames(styles['social'], className)}>
        <Tooltip label={tooltipLabel} disabled={tooltipDisabled}>
          <GoogleAuth
            disabled={disabled}
            renderButton={true}
            onSuccess={this.onGoogleSuccess}
            onFailure={this.responseFailed}
          />
        </Tooltip>

        <Tooltip label={tooltipLabel} disabled={tooltipDisabled}>
          <FacebookAuth
            className={classNames(buttonClassNames, 'btn_blue')}
            disabled={disabled}
            onSuccess={this.onFacebookSuccess}
            onFailure={this.responseFailed}
            topBlank
          >
            <IconGroup type={'facebook'} />
            <span className={styles['social__btn_label']}>Sign in with Facebook</span>
          </FacebookAuth>
        </Tooltip>

        <div className={styles['social__error']}>
          {providerError || externalError}
        </div>
      </div>
    );
  }

  private onGoogleSuccess = (response: IGoogleResponse): void => {
    this.props.onAuth(mapGoogleResponse(response));
  };

  private onFacebookSuccess = (response: IFacebookResponse): void => {
    this.props.onAuth(mapFacebookResponse(response));
  };

  private responseFailed = (): void => {
    this.setState({providerError: CANNOT_AUTHORIZE});
  };
}
